import React, { useEffect, useState } from 'react';

const DocumentoItem = ({documento, index, setDocumentos}) => {
    const onChangeDocumento = (documentoChanged) => {
        setDocumentos(documentos => documentos.map((doc, i) => i === index ? documentoChanged : doc));
    };
    
    const onDeleteDocumento = () => {
        if (documento.id) {
            onChangeDocumento({...documento, borrar: 1})
        } else {
            setDocumentos(documentos => documentos.filter((_, i) => i !== index));
        }
    };

    useEffect(() => {
        if (documento.id && !documento.nombre) {
            onChangeDocumento({...documento, nombre: `documento_${documento.id}}`});
        }
    }, []);

    return (
        <div className="row form-group">
            <div className="col col-md-5 col-sm-12">
                <div className="col col-md-12">
                    <label
                        htmlFor="nombre_documento"
                        className="label form-control-label"
                    >
                        Nombre *:
                    </label>
                </div>
                <input
                    type="text"
                    name={`documentos[${index}][nombre]`}
                    className='form-control'
                    value={documento.nombre ?? ''}
                    onChange={e => onChangeDocumento({...documento, nombre: e.target.value})}
                />
            </div>

            <div className="col col-md-6 pt-4">
                <div className="col col-md-12">
                    <input
                        type='file'
                        className='form-control-file'
                        style={{display: "none"}}
                        id={`documentos[${index}][archivo]`}
                        name={`documentos[${index}][archivo]`}
                        placeholder={"Subir archivo"}
                        onChange={e => onChangeDocumento({...documento, filename: e.target.value, archivo: e.target.files[0]})}
                    />
                    
                    <label className='form-control-file btn btn-light' style={{overflow: 'hidden'}} htmlFor={`documentos[${index}][archivo]`}>
                        {documento.id || documento.filename  ? ((documento.filename?.replace(/^.*[\\/]/, '') ?? documento.nombre) ?? `documento_${documento.id}`) : "Ningún documento seleccionado"}
                    </label>
                </div>
            </div>

            <div className="col col-md-1 pt-4">
                <button type='button' className='btn' onClick={onDeleteDocumento}><i className="fas fa-trash"></i></button>
            </div>

        </div>
    );
}

export default DocumentoItem;